import type { BoxDetail } from "./index.js";
import { STOREFRONT_RARITY_TIERS, type StorefrontRarityKey } from "./rarityTiers.js";

/** A flat square in one color, as an item image the preview reel can show without a network. */
function swatch(color: string): string {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200"><rect x="30" y="30" width="140" height="140" rx="24" fill="${color}"/></svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}

/** Each tier's worth and odds in the sample box; its name and color are the tier's own. */
const TIER_ODDS: Record<StorefrontRarityKey, { value: number; weight: number }> = {
  "0": { value: 200, weight: 600_000 },
  "1": { value: 600, weight: 250_000 },
  "2": { value: 1_500, weight: 100_000 },
  "3": { value: 5_000, weight: 40_000 },
  "4": { value: 20_000, weight: 10_000 },
};

const ITEMS = STOREFRONT_RARITY_TIERS.map((tier) => ({
  name: tier.label,
  color: tier.default,
  ...TIER_ODDS[tier.key],
}));

/**
 * A made-up box for previewing an opener where no real box is at hand (the opener style editors,
 * and the Shopify Appearance previews while the shop sells no box): one item per rarity tier, so
 * the rarity colors show. Never saved or opened.
 */
export const SAMPLE_OPENER_BOX: BoxDetail = {
  id: "opener-style-preview",
  name: "Preview box",
  slug: "opener-style-preview",
  imageUrl: swatch("#8b5cf6"),
  priceCents: 1_000,
  version: 1,
  isCatalog: false,
  featured: false,
  openedCount: 0,
  ev: ITEMS.reduce((sum, item) => sum + (item.value * item.weight) / 1_000_000, 0),
  dropTable: ITEMS.map((item) => ({
    itemId: `preview-${item.name.toLowerCase()}`,
    itemSource: "CATALOG",
    name: item.name,
    imageUrl: swatch(item.color),
    value: item.value,
    weight: item.weight,
  })),
  dropTableHash: "",
  refreshedAt: new Date(0).toISOString(),
};
